import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { parse } from 'date-fns';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { AeroexpressTrip } from '@websky/graphql';
import { Reducer } from '../AeroexpressPopup/hooks';
import { format } from '../../../utils';
import { Money } from '../../../Money';
import AeroexpressPassenger from '../AeroexpressPassenger/AeroexpressPassenger';
import { isRoundTrip as getIsRoundTrip } from '../AeroexpressPopup/utils';

interface Props {
	className?: string;
	state: Reducer;
	direction: string;
	trips: AeroexpressTrip[];
	allPassengers: boolean;
	onChange: (direction: string, trip: AeroexpressTrip) => void;
}

const AeroexpressSegment: React.FC<Props> = ({ className, state, direction, trips, allPassengers, onChange }) => {
	const { AeroexpressSegment: css } = useTheme('CheckoutAdditionalService');
	const { t } = useTranslation('Checkout');

	const trip = trips[0];
	const isRoundTrip = getIsRoundTrip(trip);

	// TODO: uncomment this when php was ready
	// const passengerTypes = useMemo(() => {
	// 	const passengerTypesSet = new Set<string>();
	//
	// 	trips.forEach(trip => {
	// 		trip.fares?.forEach(fare => {
	// 			fare.passengers?.forEach(passenger => {
	// 				passengerTypesSet.add(passenger.type);
	// 			});
	// 		});
	// 	});
	//
	// 	return [...passengerTypesSet];
	// }, [trips]);

	const onChangeHandler = (trip: AeroexpressTrip) => onChange(direction, trip);

	return (
		<div className={cn(css.container, className)}>
			<div className={css.header}>
				<div className={css.info}>
					<div className={css.date}>
						{format(parse(trip.departureDate, 'HH:mm dd.MM.yyyy', new Date()), 'dd.MM.yyyy')}
					</div>
					<div className={css.direction}>
						{[trip.fromStation.name, trip.toStation.name].filter(Boolean).join(' – ')}
						<span className={css.type}>{isRoundTrip ? t('And back') : t(direction)}</span>
					</div>
				</div>

				<div className={css.prices}>
					{trips.map(trip => (
						<div key={trip.id} className={css.price}>
							{t(`Class_${trip.class}`)}
							<Money money={trip.price} moneyClassName={css.money} />
						</div>
					))}

					{/* TODO: uncomment this when php was ready */}
					{/*{trips.map(trip =>*/}
					{/*	trip.fares?.map((fare, index) => (*/}
					{/*		<div key={`${trip.id}-${index}`} className={css.price}>*/}
					{/*			{t(`Class_${fare.class}`)}*/}
					{/*			<Money*/}
					{/*				money={allPassengers ? fare.price : fare.totalPrice}*/}
					{/*				moneyClassName={css.money}*/}
					{/*			/>*/}
					{/*		</div>*/}
					{/*	))*/}
					{/*)}*/}
				</div>
			</div>
			<div className={css.passengers}>
				<AeroexpressPassenger
					className={css.passenger}
					label={t('All passengers')}
					trips={trips}
					value={state[direction]}
					onChange={onChangeHandler}
				/>

				{/* TODO: uncomment this when php was ready */}
				{/*{!allPassengers ? (*/}
				{/*	<AeroexpressPassenger*/}
				{/*		className={css.passenger}*/}
				{/*		label={t('All passengers')}*/}
				{/*		trips={trips}*/}
				{/*		value={state[direction]}*/}
				{/*		onChange={onChangeHandler}*/}
				{/*	/>*/}
				{/*) : (*/}
				{/*	passengerTypes.map((type, index) => (*/}
				{/*		<AeroexpressPassenger*/}
				{/*			key={type}*/}
				{/*			className={css.passenger}*/}
				{/*			label={*/}
				{/*				<>*/}
				{/*					<div className={css.number}>{index + 1}</div>*/}
				{/*					<span className={css.label}>*/}
				{/*						{t('Passenger')}*/}
				{/*						<span>{t(`PassengerTypes:${type}`)}</span>*/}
				{/*					</span>*/}
				{/*				</>*/}
				{/*			}*/}
				{/*			trips={trips}*/}
				{/*			onChange={onChangeHandler}*/}
				{/*		/>*/}
				{/*	))*/}
				{/*)}*/}
			</div>
		</div>
	);
};

export default AeroexpressSegment;
